import { HomePageHero } from "./_components/Hero";
import { HomePageValuePropSection } from "./_components/ValueProps";
import { HomePageFooterCta } from "./_components/FooterCta";

export const HomePage = () => {
    return (
        <>
            <HomePageHero />
            <HomePageValuePropSection />
            <HomePageFooterCta />
        </>
    );
};
